export const OPTIMIZELY_FLAGS = {
	FACILITY_PAGE_REDESIGN: "sdc_facility_redesign_ab_testing_26Q1",
	CLP_TESTING: "sdc_clp_ab_testing_26Q1",
	UNIT_RESERVATION_AA_TEST: "sdc_unit_reservation_ab_testing_26Q1"
};
